import { render } from "./AllMedicalInsurances.vue?vue&type=template&id=2708ca30&scoped=true"
import script from "./AllMedicalInsurances.vue?vue&type=script&lang=js"
export * from "./AllMedicalInsurances.vue?vue&type=script&lang=js"

import "./AllMedicalInsurances.vue?vue&type=style&index=0&id=2708ca30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2708ca30"]])

export default __exports__